export const name = 'SignUpController';

export default function SignUpController(
  $location,
  $q,
  rnDevice,
  rnHttp,
  rnLocale,
  rnInstructionsService,
  $state,
  $stateParams,
  $timeout,
  $translate,
  $gzAnalytics,
  $window,
  rnRegistry
) {
  //noinspection BadExpressionStatementJS
  'ngInject';

  const US_VALIDATORS = {
    region: {
      maxlength: 2,
      validator: 'Validator.AAA.USState'
    },
    postalCode: {
      maxlength: 10,
      validator: 'Validator.AAA.USPostalCode'
    }
  };

  const CANADA_VALIDATORS = {
    region: {
      maxlength: 2,
      validator: 'Validator.AAA.CAProvidences'
    },
    postalCode: {
      maxlength: 7,
      validator: 'Validator.AAA.CAPostalCode'
    }
  };

  const DEFAULT_VALIDATORS = {
    region: {
      maxlength: 100,
      validator: 'Validator.AAA.DescriptionUnicode'
    },
    postalCode: {
      maxlength: 35,
      validator: 'Validator.AAA.PostalCode'
    }
  };

  const EMAIL_SERVICE = 'email_service';
  const EMAIL_SELF_INVITE_PATH   = 'invitations/self';
  const SUPPORT_SERVICE = 'supportapp_service';
  const CAPTCHA_PATH = 'captcha/key';
  const PORTAL_SERVICE = 'portal_service';
  const US_COUNTRY_CODE = 'US';
  const CANADA_COUNTRY_CODE = 'CA';

  let locale = {};
  let myParams = {};
  let captchaId;
  let incoming3D = false;

  let vm = this;

  vm.loading = true;
  vm.submitting = false;
  vm.validators = DEFAULT_VALIDATORS;
  vm.signupForm = null;
  vm.deviceTypesAndModels = null;
  vm.device = {};
  vm.internalId = null;
  vm.deviceModels = [];
  vm.titles = [];
  vm.address = null;
  vm.showScitexId = false;
  vm.showScitexIdHelp = false;
  vm.helpCenterEnabled = false;

  // controller functions
  vm.getDeviceTypesAndModels = getDeviceTypesAndModels;
  vm.typeChanged = typeChanged;
  vm.modelChanged = modelChanged;
  vm.countryChanged = countryChanged;
  vm.getCountry = getCountry;
  vm.getCountries = getCountries;
  vm.disableSubmit = disableSubmit;
  vm.submit = submit;
  vm.cancel = cancel;
  vm.renderRecaptcha = renderRecaptcha;
  vm.executeRecaptcha = executeRecaptcha;
  vm.scitexIdHelpClicked = scitexIdHelpClicked;

  vm.$onInit = onInit;

  ////////////////////////
  function onInit() {
    myParams.data = $stateParams.data;
    vm.inputDevice = _.get($stateParams, 'data.device');
    if (vm.inputDevice) {
      _.set(vm.device, 'type', vm.inputDevice.type);
      _.set(vm.device, 'model', vm.inputDevice.model);
      _.set(vm.device, 'serialNumber', vm.inputDevice.serialNumber);
      if (vm.inputDevice.securityCode) {
        vm.activationDetails = {
          securityCode: vm.inputDevice.securityCode,
        };
      }
    }
    getHelpCenterEnabledRegistryKey();

    let promises = [];
    promises.push(getDeviceTypes());
    promises.push(getCountries());
    promises.push(getSiteKey());
    promises.push(getLocale());

    return $q.all(promises)
      .then((data) => {
        initDeviceTypesAndModels(data[0]);
        vm.countries = data[1];
        parseParams();
      })
      .finally(() => {
        countryChanged();
        initTitles();
        if (!$window.grecaptcha) {
          vm.errorKey = 'register.register.SignUp_Error_NoCaptcha';
          vm.noCaptcha = true;
          $gzAnalytics.event('Sign Up - no captcha');
        }
        vm.loading = false;
        });
  }

  function getLocale() {
    return rnLocale.getBestFit().then(l => {
      locale = l;
    });
  }

  function getSiteKey() {
    return rnHttp.get(SUPPORT_SERVICE, CAPTCHA_PATH, {version: 1}).then(resp => {
      vm.captchaSiteID = resp.data.key;
    });
  }

  function renderRecaptcha() {
    if ($window.grecaptcha) {
      captchaId = $window.grecaptcha.render('recaptchaSignUp', {
        sitekey: vm.captchaSiteID,
        callback: submit,
        // Recaptcha errors are also handled in submit method
        'error-callback': submit,
        'expired-callback': submit,
      });
    }
  }

  function executeRecaptcha() {
    if ($window.grecaptcha) {
      $window.grecaptcha.execute(captchaId);
      $gzAnalytics.eventClick('Sign up - Captcha executed');
    }
  }

  function getDeviceTypes() {
    return rnDevice.getDeviceModels().then(deviceModelList => {
      vm.deviceTypesAndModels = deviceModelList;
    });
  }

  function initDeviceTypesAndModels(deviceModelList) {
    // Remove all unreleased models
    _.forEach(vm.deviceTypesAndModels, function(deviceModels) {
      _.remove(deviceModels.models, (model) => {
        return model.released === false;
      });
    });

    // Remove model type if no models left for it
    _.remove(vm.deviceTypesAndModels, (modelType) => {
      return modelType.models.length === 0;
    });

    // Sort based on localized values
    let temp = [];
    let name = '';
    for (let i = 0; i < vm.deviceTypesAndModels.length; i++) {
      name = $translate.instant('devices.devices.' + vm.deviceTypesAndModels[i].name);
      temp.push({originalObject: vm.deviceTypesAndModels[i], localizedName: name});
    }
    vm.deviceTypesAndModels = _.pluck(_.sortBy(temp, 'localizedName'), 'originalObject');

    let uiTypesAndModels = [];
    _.forEach(vm.deviceTypesAndModels, (deviceType) => {
      // TODO: Audit code - is it better to filter on deviceGroup?
      if (deviceType.name === 'IndigoPress' ||
        deviceType.name === 'ScitexPress' ||
        deviceType.name === 'IHPSPress' ||
        deviceType.name === 'LatexPrinter' ||
        deviceType.name === 'DesignjetPrinter' ||
        deviceType.name === 'PageWideXLPrinter' ||
        deviceType.name === 'ThreeDPrinter' ||
        deviceType.name === 'TextilePrinter' ) {
        uiTypesAndModels.push(deviceType);
      }
    });
    vm.deviceTypesAndModels = uiTypesAndModels;
  }

  function getDeviceTypesAndModels() {
    return vm.deviceTypesAndModels;
  }

  function typeChanged(deviceType) {
    vm.canSelfInvite = false;
    vm.showPrinterInfo = false;
    vm.showPressInfo = false;
    vm.showAllInfo = false;
    vm.showScitexId = false;
    vm.showScitexIdHelp = false;
    vm.device.model = undefined;
    vm.bgBU = undefined;

    // TODO: Audit code - doesn't AAA create the internal IDs? Or is this just for the support request?
    // Create an appropriate internalId for the GBU
    vm.internalId = {
        internalIdType: 'PSPId'
    };

    switch (deviceType) {
      case 'IndigoPress':
        vm.showPressInfo = true;
        vm.showAllInfo = true;
        vm.internalId.gbu = 'Indigo';
        break;
      case 'ScitexPress':
        vm.showPrinterInfo = true;
        vm.showAllInfo = true;
        vm.showScitexId = true;
        vm.internalId.gbu = 'Scitex';
        delete vm.device.scitexId;
        break;
      case 'IHPSPress':
        vm.showPressInfo = true;
        vm.showAllInfo = true;
        vm.internalId.gbu = 'IHPS';
        break;
      case 'LatexPrinter':
      case 'TextilePrinter':
      case 'PageWideXLPrinter':
        vm.showPrinterInfo = true;
        vm.internalId.gbu = 'Latex';
        break;
      case 'DesignjetPrinter':
        vm.showPrinterInfo = true;
        vm.internalId.gbu = 'Designjet';
        break;
      case 'ThreeDPrinter':
        vm.showAllInfo = false;
        vm.internalId.gbu = 'ThreeD';
        vm.bgBU = '3D';
        myParams.bu = '3D';
        break;
      default:
        vm.internalId = null;
        break;
    }

    vm.deviceModels = _.result(_.find(vm.deviceTypesAndModels, {'name': deviceType}), 'models');
    if (vm.deviceModels) {
      vm.deviceModels.forEach(model => {
        model.localizedName = $translate.instant(model.modelNameKey);
      });

      if (deviceType === 'ThreeDPrinter') {
        // Remove the old (duplicate) 3D models that used the friendly name as the model in the DB
        _.remove(vm.deviceModels, (model) => {
          return model.modelName.startsWith('HP Jet Fusion 3D');
        });

        // Remove the old model A devices that are internal only and will not be released to customers
        _.remove(vm.deviceModels, (model) => {
          return model.modelName === "M0P44A" || model.modelName === "M0P49A";
        });
      }

      // Sort models based on localized names
      let temp = [];
      let name = '';
      for (let i = 0; i < vm.deviceModels.length; i++) {
        name = $translate.instant(vm.deviceModels[i].modelNameKey);
        temp.push({originalObject: vm.deviceModels[i], localizedName: name});
      }
      vm.deviceModels = _.pluck(_.sortBy(temp, 'localizedName'), 'originalObject');
    }
  }

  function modelChanged() {
    if (vm.device.serialNumber) {
      delete vm.device.serialNumber;
    }

    if (vm.device.scitexId) {
      delete vm.device.scitexId;
    }
  }

  function initTitles() {
    let titles = [];
    titles.push({key: 'Business Owner', value: ($translate.instant('register.register.SignUp_Business_Owner'))});
    titles.push({key: 'Production Manager', value: ($translate.instant('register.register.SignUp_Production_Manager'))});
    titles.push({key: 'IT Manager', value: ($translate.instant('register.register.SignUp_IT_Manager'))});
    titles.push({key: 'Press Operator', value: ($translate.instant('register.register.SignUp_Press_Operator'))});
    titles.push({key: 'Other', value: ($translate.instant('register.register.SignUp_Other_Title'))});
    vm.titles = titles;
  }

  function getCountry(isoCode) {
    return _.find(vm.countries, {isoCode: isoCode});
  }

  function getCountries() {
    let portalCountriesOpts = {
      cache: true,
      params: {
        locale: locale.value
      }
    };

    return rnHttp.get(PORTAL_SERVICE, 'preferences/countries', portalCountriesOpts)
      .then(response => response.data);
  }

  function countryChanged() {
    let country = getCountry(vm.country);
    if (country) {
      switch (country.isoCode) {
        case US_COUNTRY_CODE:
          vm.validators = US_VALIDATORS;
          break;
        case CANADA_COUNTRY_CODE:
          vm.validators = CANADA_VALIDATORS;
          break;
        default:
          vm.validators = DEFAULT_VALIDATORS;
          break;
      }

      // Semi-hack to trigger validation on region and postal code gz-regex-validator has
      // had a chance to pick up the new value (after appropriate digest cycle)
      $timeout(resetForm, 100);
    }
  }

  function resetForm() {
    if (vm.signupForm.state && vm.signupForm.state.$viewValue !== undefined && vm.signupForm.state.$viewValue.length > 0) {
      vm.signupForm.state.$setDirty();
      vm.signupForm.state.$setTouched();
      vm.signupForm.state.$validate();
    }

    if (vm.signupForm.postalCode && vm.signupForm.postalCode.$viewValue !== undefined && vm.signupForm.postalCode.$viewValue.length > 0) {
      vm.signupForm.postalCode.$setDirty();
      vm.signupForm.postalCode.$setTouched();
      vm.signupForm.postalCode.$validate();
    }
  }

  function formatRequest() {
    if (vm.internalId) {
      _.set(vm, 'request.internalId', vm.internalId);
    }

    if (vm.models) {
      vm.device.model = vm.models.join(', ').substring(0, 99);
    }

    if (vm.device && vm.device.model) {
      // Only send the deviceIdentifier if the user has provided info for the device
      _.set(vm, 'request.deviceIdentifier', vm.device);

      // Add device to invitation payload so Getting Started can use information
      // Only do this if we don't have a security code (sc scenario automatically adds the device)
      if (!_.get(vm, 'inputDevice.securityCode') && rnInstructionsService.getInstallMethods(vm.device.type, vm.device.model).sn) {
        let payload = {
          onboard: {
            devices: [
              {
                name: vm.device.serialNumber,
                type: vm.device.type,
                partNumber: vm.device.model,
                serialNumber: vm.device.serialNumber,
              }
            ],
          }
        };
        _.set(vm, 'request.ext_payload', payload);
      }
    }

    if (vm.activationDetails) {
      _.set(vm, 'request.deviceActivationDetails', vm.activationDetails);
    }

    if (vm.userTitle) {
      _.set(vm, 'request.title', vm.userTitle);
      if (vm.otherTitle) {
        _.set(vm, 'request.title', vm.otherTitle);
      }
    }

    if (vm.company) {
      _.set(vm, 'request.company', vm.company);
    }

    if (vm.address) {
      _.set(vm, 'request.address', vm.address);
      _.set(vm, 'request.primaryPhone', vm.primaryPhone);
    }

    if ($window.grecaptcha) {
      _.set(vm, 'request.userInput', $window.grecaptcha.getResponse(captchaId));
    }
  }

  function disableSubmit() {
    if (vm.submitting) {
      return true;
    }

    if (vm.signupForm.$invalid) {
      return true;
    }

    if (!vm.device.type) {
      return true;
    }

    if (vm.showPressInfo && vm.device.serialNumber && vm.device.serialNumber.trim() === '') {
      return true;
    }

    return false;
  }

  function submit() {
    if (vm.submitting) {
      return;
    }

    vm.submitting = true;
    delete vm.errorKey;
    formatRequest();

    if (!vm.request.userInput || (vm.request.userInput && vm.request.userInput === '')) {
      vm.errorKey = 'register.register.SignUp_Error_Captcha';
      vm.submitting = false;
      $gzAnalytics.event('Sign Up - captcha error');
      return;
    }

    vm.request.languageCode = locale.value;

    let config = {
      version: 1,
      rhino: {
        allow401: true
      }
    };

    return rnHttp.post(EMAIL_SERVICE, EMAIL_SELF_INVITE_PATH, vm.request, config).then(response => {
      let invitation = response.data;

      if (invitation.id) {
        let params = {
          invitationId: invitation.id,
          data: {
            email: vm.request.email,
            firstName: vm.request.firstName,
            lastName: vm.request.lastName
          },
          signout: true
        };

        if (vm.bu) {
          params.bu = vm.bu;
        }

        if (vm.bgBU) {
          params.bu = vm.bgBU;
        }

        $gzAnalytics.event('Sign Up - success with invitation id');
        return $state.go('acceptAccount', params);
      }
      else {
        vm.showAllInputs = false;
        vm.success = true;
        $gzAnalytics.event('Sign Up - success no invitation id');
      }

    })
      .catch((error) => {
        if ($window.grecaptcha) {
          $window.grecaptcha.reset(captchaId);
        }

        let statusCode = _.get(error, 'data.smsError.statusCode', -1);
        let subCode = _.get(error, 'data.smsError.subCode',  null);
        $gzAnalytics.event('Sign Up - error', {label: `${statusCode} - ${subCode}`});

        if (statusCode === 401) {
          if (subCode === 1019) {
            // Serial number is invalid
            vm.errorKey = 'register.register.SignUp_Device_SN_Error';
          }
          else if (subCode === 1022) {
            // The serial number has an invalid format, which we will assume is because it needs to be uppercase
            vm.errorKey = 'devices.devices.Device_Serial_Number_Incorrect_Case';
          }
          else if (subCode === 1020) {
            // Issue validating the serial number (the service is probably down)
            vm.errorKey = 'register.register.SignUp_Device_Validation_Internal_Error';
          }
          else {
            vm.errorKey = 'register.register.SignUp_Error';
          }
        }
        else if (statusCode === 409) {
          if (subCode === 1002) {
            // Device exists in another org
            vm.errorKey = 'register.register.SignUp_Device_Conflict';
          }
          else {
            vm.errorKey = 'register.register.Email_Conflict';
          }
        }
        else {
          vm.errorKey = 'register.register.SignUp_Error';
        }
      })
      .finally(() => {
        vm.submitting = false;
      });
  }

  function cancel() {
    myParams.signout = true;
    if (!incoming3D && myParams.bu) {
      delete myParams.bu;
    }

    $state.go('signin', myParams);
    $gzAnalytics.eventCancel('Sign Up - Cancel clicked');
  }

  function parseParams() {
    let queryParams = $location.search();
    if ($stateParams.bu) {
      incoming3D = true;
      myParams.bu = $stateParams.bu;
      vm.bu = $stateParams.bu;

      switch (vm.bu) {
        case '3D':
          vm.deviceTypesAndModels = vm.deviceTypesAndModels.filter(dt => {
            return dt.name === 'ThreeDPrinter';
          });
          vm.device.type = 'ThreeDPrinter';
          typeChanged(vm.device.type);
          break;
      }
    }
  }

  function scitexIdHelpClicked() {
    vm.showScitexIdHelp = !vm.showScitexIdHelp;
  }

  function getHelpCenterEnabledRegistryKey() {
    rnRegistry.getRegistry().then(registry => {
      vm.helpCenterEnabled = registry.keys.helpCenterEnabled;
    });
  }
}



// WEBPACK FOOTER //
// ./components/sign-up/sign-up.controller.js